import { getAlarm, postAlarm, putAlarm } from '../api-config';

const sacService = '/sac';

// SAC credentials (sessionToken/providerId/providerName) are injected by the
// apiSac request interceptor in api-config.ts — callers must NOT pass them.

// Alerts Queue
// `size`/`order` son opcionales: la sanity-check inicial (commonSlice.getSacInfoAsync)
// no pagina la cola.
export const getAlarmsQueue = (operatorId: any, size?: any, order?: any) =>
  getAlarm(sacService, `/alerts/${operatorId}`, null, { size, order });

export const getAlarmsQueueLastUpdate = (operatorId: any) =>
  getAlarm(sacService, `/alerts/${operatorId}/lastUpdate`);

export const getAlarmData = (alarmId: any) =>
  getAlarm(sacService, `/alerts/data/${alarmId}`);

export const postConsumeAlarm = (operatorId: any, alarmId: any) =>
  postAlarm(sacService, `/alerts/handle/${operatorId}/${alarmId}/${operatorId}`, {});

export const postCloseAlarm = (operatorId: any, alarmId: any) =>
  postAlarm(sacService, `/alerts/close/${operatorId}/${alarmId}/${operatorId}`, {});

export const postLeaveMemberAlarm = (operatorId: any, alarmId: any, number: any) =>
  postAlarm(sacService, `/alerts/leave/${operatorId}/${alarmId}/${number}`, {});

export const postDeafMemberAlarm = (operatorId: any, alarmId: any, number: any) =>
  postAlarm(sacService, `/alerts/deaf/${operatorId}/${alarmId}/${number}`, {});

export const postUndeafMemberAlarm = (operatorId: any, alarmId: any, number: any) =>
  postAlarm(sacService, `/alerts/undeaf/${operatorId}/${alarmId}/${number}`, {});

export const postMuteMemberAlarm = (operatorId: any, alarmId: any, number: any) =>
  postAlarm(sacService, `/alerts/mute/${operatorId}/${alarmId}/${number}`, {});

export const postUnmuteMemberAlarm = (operatorId: any, alarmId: any, number: any) =>
  postAlarm(sacService, `/alerts/unmute/${operatorId}/${alarmId}/${number}`, {});

export const postParkAlarm = (operatorId: any, alarmId: any) =>
  postAlarm(sacService, `/alerts/park/${operatorId}/${alarmId}`, {});

// Desambiguacion de paciente: cuando un numero entrante coincide con varios
// pacientes, la alerta llega "Sin identificar" con candidatos a elegir.
export const getAlertCandidates = (alarmId: any) =>
  getAlarm(sacService, `/alerts/candidates/${alarmId}`);

export const postSelectAlertClient = (operatorId: any, alarmId: any, clientId: any) =>
  postAlarm(sacService, `/alerts/selectClient/${operatorId}/${alarmId}/${clientId}`, {});

export const postPlayDtmf = (operatorId: any, alarmId: any, number: any, dtmf: any) =>
  postAlarm(sacService, `/alerts/play/${operatorId}/${alarmId}/${number}/${dtmf}`, {});

export const postCallAlarm = (data: any, params: any) => postAlarm(sacService, `/call`, data, params);

export const postJoinExternal = (operatorId: any, alarmId: any, externalNumber: any, clientId: any) =>
  postAlarm(sacService, `/alerts/joinExternal/${operatorId}/${alarmId}/${externalNumber}/${clientId}`, {});

// ------------------------------------------------------------------ feature expedientes (F5)
// Cola v2 agrupada por expediente y operaciones sobre el expediente completo.
// La cola v1 (por alerta) se retiró del front en F8 — paso 11; las operaciones por alerta
// de arriba siguen usándose desde la atención del expediente.

export const getExpedientQueue = (operatorId: any, init?: any, size?: any, order?: any) =>
  getAlarm(sacService, `/alerts/expedients/${operatorId}`, null, { init, size, order });

export const postHandleExpedient = (expedientId: any, operatorId: any) =>
  postAlarm(sacService, `/expedients/${expedientId}/handle/${operatorId}`, {});

export const postParkExpedient = (expedientId: any, operatorId: any) =>
  postAlarm(sacService, `/expedients/${expedientId}/park/${operatorId}`, {});

// Cancelar la reserva (afinidad) de un expediente antes de que caduque.
export const postReleaseExpedient = (expedientId: any, operatorId: any) =>
  postAlarm(sacService, `/expedients/${expedientId}/release/${operatorId}`, {});

export const postTerminateExpedient = (expedientId: any, operatorId: any) =>
  postAlarm(sacService, `/expedients/${expedientId}/terminate/${operatorId}`, {});

export const postSplitExpedient = (
  expedientId: any,
  operatorId: any,
  alertIds: any[],
  targetExpedientId?: any,
  closedEventIds?: any[],
) =>
  postAlarm(sacService, `/expedients/${expedientId}/split/${operatorId}`, { alertIds, targetExpedientId, closedEventIds });

// Alerts Queue config
export const getOperatorGroups = (operatorId: any) =>
  getAlarm(sacService, `/operator/${operatorId}/alert/groups`);

export const putOperatorGroups = (operatorId: any, data: any) =>
  putAlarm(sacService, `/operator/${operatorId}/alert/groups`, data);

// Estado en vivo del expediente en el SAC (diálogo de expediente): clase, prioridad, pendientes,
// quién lo atiende y desde cuándo, último operador, reserva. Solo lectura.
export const getExpedientState = (expedientId: any, operatorId: any) =>
  getAlarm(sacService, `/expedients/${expedientId}/state/${operatorId}`, null, null);

// Historial del expediente en el SAC (altas, extracciones, atenciones, aparcados, llamadas).
export const getExpedientHistory = (expedientId: any, operatorId: any) =>
  getAlarm(sacService, `/expedients/${expedientId}/history/${operatorId}`, null, null);
